import { createStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles/createMuiTheme';

export const styles = (theme: Theme) => createStyles({
	bodyColor: {
		backgroundColor: 'white'
	},
	headerLeft: {
		fontSize: '20px',
		float:'left'
	},
	marginTopx: {
		marginTop: theme.spacing.unit
	},
	marginBottomx: {
		marginBottom: theme.spacing.unit
	},
	borderDefault: {
		border: "1px solid #DFDFDF"
	},
	checkboxCSS: {
		color: "#4CAF50",
		'&$checked': {
			color: "#43A047",
		},
	},
	checked: {},
	imageWidth: {
		maxHeight: "250px",
		maxWidth: "250px"
	},
	link: {
		color: "#2196F3",
		cursor: "pointer",
		textDecoration:"underline"
	},
	pointerCss: {
		cursor: "pointer"
	}
});
